import * as types from "./types";

const mutations = {
    [types.LOADING_MARKETINGLEADS](state, payload) {
        state.loading = payload;
    },
    [types.GET_MARKETINGLEADS](state, payload) {
        state.marketingleads = payload;
    },
    [types.POST_MARKETINGLEADS_ID](state, payload) {
        state.marketingleads.push(payload);
    },
    [types.GET_MARKETINGLEADS_ID](state, payload) {
        state.marketingleadid = payload;
    },
    [types.UPDATE_MARKETINGLEADS](state, payload) {
        const index = state.marketingleads.findIndex((item) => item.id === payload.id);
        state.marketingleads.splice(index, 1, payload);
    },
    [types.DELETE_MARKETINGLEADS](state, payload) {
        const index = state.marketingleads.findIndex((item) => item.id === payload);
        state.marketingleads.splice(index, 1);
    }
};

export default mutations;